module.exports = __webpack_public_path__ + "img/img18.e015f576.png";